import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./style/style.css";
import PrivateRoute from "./redux/PrivateRoute";
import React, { Suspense } from "react";
import Login from "./page/Login";
import LoaderCard from "./components/LoaderCard";
import ManagelistStatus from "./page/ManagelistStatus";
import Pendinglist from "./page/Pendinglist";
import TeamDashboard from "./page/TeamDashboard";
import RoleProtectedRoute from "./redux/RoleProtectedRoute";
const AddLead = React.lazy(() => import("./page/AddLead"));
const Dashboard = React.lazy(() => import("./page/Dashboard"));
const ManageLead = React.lazy(() => import("./page/ManageLead"));
const Followup = React.lazy(() => import("./page/Followup"));
const NotInteredtedLead = React.lazy(() => import("./page/NotInterestedLead"));
const DeadLead = React.lazy(() => import("./page/DeadLead"));
const Calender = React.lazy(() => import("./page/Calender"));
const Password = React.lazy(() => import("./components/Password"));
const Profile = React.lazy(() => import("./page/Profile"));
const UpdateLead = React.lazy(() => import("./page/UpdateLead"));
const Notification = React.lazy(() => import("./page/Notification"));
function App() {
  return (
    <Router basename="/user/">
      <Suspense fallback={<LoaderCard />}>
        <Routes>
          <Route element={<PrivateRoute />}>
            <Route exact path="/" element={<Dashboard />} />
            <Route exact path="/addlead" element={<AddLead />} />
            <Route exact path="/managelead" element={<ManageLead />} />
            <Route exact path="/managelead/:id" element={<UpdateLead />} />
            <Route exact path="/lead" element={<ManagelistStatus />} />
            <Route exact path="/followup" element={<Followup />} />
            <Route
              exact
              path="/not-interested-lead"
              element={<NotInteredtedLead />}
            />
            <Route exact path="/dead-lead" element={<DeadLead />} />
            <Route exact path="/calender" element={<Calender />} />
            <Route exact path="/profile" element={<Profile />} />
            <Route exact path="/password" element={<Password />} />
            <Route exact path="/notification" element={<Notification />} />
            <Route exact path="/pending" element={<Pendinglist />} />
            <Route element={<RoleProtectedRoute allowedRoles={[3]} />}>
              <Route exact path="/team" element={<TeamDashboard />} />
            </Route>
          </Route>
          <Route exact path="/login" element={<Login />} />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
